<template>
    <div class="sm-admin-mail">
    <div class="sm-admin-mail__main">
      <mail-top />
      <mail-list 
        @summary="handleSummary"
      />
    </div>
    <div class="sm-admin-mail__left">
      <div class="sm-admin-mail__left-tabs">
        <a
          v-for="item in tabs"
          :key="item.tab"
          :class="{
            'active': item.tab == currentTab || item.hover
          }"
          @mouseenter="item.hover = true"
          @mouseleave="item.hover = false"
          @click.prevent="switchTab(item.tab)"
        >
          <hint-wrap 
            :text="item.text"
            :horizontal="true"
            :delay="0"
          >
            <template slot="content">
              <include-svg :name="item.tab == currentTab || item.hover ? item.iconActive : item.icon" />
            </template>
          </hint-wrap>
          
        </a>
      </div>
      <div class="sm-admin-mail__left-requests">
        <action-requests 
          v-if="Object.keys(summary).some(key => summary[key]) && !$route.query.account_id"
          :requests="summary"
          @action="handleRequest"
        />
      </div>
    </div>
    <!-- <christmas-promotion></christmas-promotion> -->
  </div>
</template>

<script>
import Top from '@/views/admin/pages/mail/Top.vue';
import List from '@/views/admin/pages/mail/List.vue';
import ActionRequests from '@/components/mail/ActionRequests';
import HintWrap from '@/components/HintWrap';
import { mapActions } from 'vuex';
// import ChristmasPromotion from '@/components/ChristmasPromotion.vue';

export default {
  name: 'mail',
  components: {
    'mail-top': Top,
    'mail-list': List,
    'action-requests': ActionRequests,
    'hint-wrap': HintWrap,
    // 'christmas-promotion': ChristmasPromotion
  },
  data() {
    return {
      tabs: [{
        tab: 'single',
        text: 'Mail Center',
        icon: 'icon-mail-single',
        iconActive: 'icon-mail-single-active',
        hover: false
      },
      {
        tab: 'group',
        text: 'Bulk Shipping',
        icon: 'icon-mail-group',
        iconActive: 'icon-mail-group-active',
        hover: false
      }],
      summary: {}
    }
  },
  computed: {
    currentTab() {
      if (this.$route.query.shortcut)
        return null;

      return this.$route.query.tab || 'single';
    }
  },
  created() {
    if(this.$route.query.tab === 'group') {
      this.getAdminList()
        .then(res => {
          this.handleSummary(res.summary);
        });
    }
  },
  methods: {
    ...mapActions({
      'getAdminList': 'mail/getAdminList'
    }),
    handleSummary(data) {
      this.summary = data;
    },
    handleRequest(name) {
      if (name)
        this.$router.push({
          query: {
            shortcut: name
          }
        });
      else
        this.$router.push({
          query: {}
        });
    },
    switchTab(tab) {
      this.$router.push({
        query: {
          tab
        }
      });
    }
  }
};
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  
  .sm-admin-mail {
    position: relative;
    max-width: 100%;
    overflow: hidden;

    &__main {
      position: relative;
      padding-left: 70px;
      z-index: 1;

      @include media('<=tiny') {
        padding-left: 50px;
      }
    }

    &__left {
      position: absolute;
      top: 0;
      left: 0;
      width: 70px;
      height: 100%;
      padding-top: 44px;
      background-color: var(--white);
      border-right: 1px solid var(--grey-line);
      z-index: 2;

      @include media('<=tiny') {
        width: 50px;
      }

      &-tabs {
        display: flex;
        flex-direction: column;
        align-items: center;

        & > a {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 48px;
          height: 48px;
          color: var(--sys);
          border-radius: 10px;
          cursor: pointer;

          @include media('<=tiny') {
            width: 40px;
            height: 40px;
          }

          &:not(:first-child) {
            margin-top: 12px;
          }

          &.active {
            background-color: var(--sys-bg);
          }
        }
      }

      &-requests {
        position: relative;
        margin-top: 50px;

        &:before {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          top: -30px;
          width: 44px;
          height: 2px;
          margin: 0 auto;
          background-color: var(--grey-add);
          border-radius: 2px;
          opacity: 0.4;
        }
      }
    }
  }
</style>